import axios from '@/plugins/axios'

export default {
  fetch(params) {
    return axios.get('roles', { params: params })
      .then(response => response.data)
  }
}
